import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { validateTurkishContent } from '../../../utils/turkishValidation';

const CreateTicketModal = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    category: 'general_inquiry',
    subject: '',
    description: '',
    priority: 'medium'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    if (!formData?.subject?.trim()) {
      setError('Konu alanı zorunludur');
      return;
    }

    const subjectError = validateTurkishContent(formData?.subject, 'Konu', 3);
    if (subjectError) {
      setError(subjectError);
      return;
    }

    if (!formData?.description?.trim()) {
      setError('Açıklama alanı zorunludur');
      return;
    }

    const descError = validateTurkishContent(formData?.description, 'Açıklama', 10);
    if (descError) {
      setError(descError);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      await onSubmit(formData);
    } catch (err) {
      setError(err?.message || 'Talep oluşturulurken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-foreground flex items-center gap-2">
            <Icon name="Plus" size={24} className="text-primary" />
            Yeni Destek Talebi
          </h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-lg hover:bg-muted flex items-center justify-center transition-colors"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start gap-3">
              <Icon name="AlertCircle" size={20} className="text-red-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Kategori <span className="text-red-500">*</span>
            </label>
            <select
              value={formData?.category}
              onChange={(e) => setFormData({ ...formData, category: e?.target?.value })}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              required
            >
              <option value="general_inquiry">Genel Soru</option>
              <option value="technical_issues">Teknik Sorun</option>
              <option value="billing">Faturalama</option>
              <option value="account">Hesap</option>
              <option value="feature_request">Özellik İsteği</option>
              <option value="bug_report">Hata Bildirimi</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Öncelik <span className="text-red-500">*</span>
            </label>
            <select
              value={formData?.priority}
              onChange={(e) => setFormData({ ...formData, priority: e?.target?.value })}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              required
            >
              <option value="low">Düşük</option>
              <option value="medium">Orta</option>
              <option value="high">Yüksek</option>
              <option value="urgent">Acil</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Konu <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={formData?.subject}
              onChange={(e) => setFormData({ ...formData, subject: e?.target?.value })}
              placeholder="Talebinizin konusunu kısaca açıklayın"
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Açıklama <span className="text-red-500">*</span>
            </label>
            <textarea
              value={formData?.description}
              onChange={(e) => setFormData({ ...formData, description: e?.target?.value })}
              placeholder="Sorununuzu veya talebinizi detaylı olarak açıklayın"
              rows={6}
              className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-none"
              required
            />
          </div>

          <div className="flex gap-3 justify-end">
            <Button
              type="button"
              variant="outline"
              size="default"
              onClick={onClose}
              disabled={loading}
            >
              İptal
            </Button>
            <Button
              type="submit"
              variant="default"
              size="default"
              iconName="Send"
              iconPosition="left"
              disabled={loading}
            >
              {loading ? 'Gönderiliyor...' : 'Talep Oluştur'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateTicketModal;